<div class="dropdown-field">
  <label class="dropdown-field__label" [for]="controlId()">
    {{ label() }}
  </label>

  <div class="dropdown-field__input-wrapper">
    <input
      #dropdownInput
      class="dropdown-field__input"
      type="text"
      autocomplete="off"
      [id]="controlId()"
      [value]="value()"
      [placeholder]="placeholder()"
      [disabled]="disabled()"
      [attr.aria-invalid]="isInvalid()"
      [attr.aria-expanded]="dropdownOpen()"
      [class.dropdown-field__input--invalid]="isInvalid()"
      (input)="onInput($event)"
      (focus)="onFocus()"
      (blur)="onBlur()"
    />

    <app-icon
      class="dropdown-field__arrow"
      [icon]="dropdownOpen() ? IconName.CHEVRON_UP : IconName.CHEVRON_DOWN"
    />
  </div>

  @if (errorMessage()) {
    <div class="dropdown-field__error">
      {{ errorMessage() }}
    </div>
  }
</div>
